import NewsTipNewsTipStatus from './NewsTipNewsTipStatus'

export default NewsTipNewsTipStatus
